import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRout";
import DashboardLayoutPage from "components/DashboardLayout";
import NewStaff from "components/dashboardPages/staff/NewStaff";
import AccessDenied from "components/AccessDenied";
// import { StaffAccess } from "shared";
import StaffShiftPage from "components/dashboardPages/shift/Shift";

const DashboardRoutes = (
  <Route
    path="/dashboard"
    element={
      <ProtectedRoute requiredAccess={[]}>
        <DashboardLayoutPage />
      </ProtectedRoute>
    }
  >
    {/* <Route index element={<DashboardHome />} /> */}

    {/* <Route
			path="staff/create"
			element={
				<ProtectedRoute requiredAccess={[StaffAccess.CEO, StaffAccess.Manager]}>
					<NewStaff />
				</ProtectedRoute>
			}
		/>

		<Route
			path="shift"
			element={
				<ProtectedRoute requiredAccess={[StaffAccess.All]}>
					<StaffShiftPage />
				</ProtectedRoute>
			}
		/> */}

    <Route path="access-denied" element={<AccessDenied />} />
    <Route path="*" element={<div>Page not found</div>} />

    {/* <Route path="staff" element={<Staff />} /> */}
  </Route>
);

export default DashboardRoutes;
